export default __webpack_public_path__ + "static/media/Punto_04_Quartiere_Venezia_ENG_Def.9bb76061.aac";